<template>
  <div class="col-12">
    <ul class="list-unstyled">
      <li>
        <strong>Dirección:</strong>
        {{ data.address }}
      </li>

      <li>
        <strong>Tel:</strong> {{ data.phone }}
      </li>
      <li>
        {{ data.phone2 }}
      </li>
      <li>
        <strong>Sitio web:</strong>
        <a
          target="_blank"
          :href="data.institution.link"
        > {{ data.institution.link }}
          <fa-icon icon="external-link-alt" />
        </a>
      </li>
    </ul>
  </div>
</template>
<script>

export default {
    name: 'Contacto',
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {};
    },
    mounted() {},
};
</script>
